import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@/contexts/AuthContext';
import { listarConversasConsumer } from '@/services/chat-app.service';
import { contarConversasComNaoLidas } from '@/lib/chat-unread';

/**
 * Contagem de conversas do cliente com mensagens por ler, para o badge da aba
 * "Mensagens". Atualiza ao focar a janela e quando uma conversa é marcada lida.
 */
export function useConversasConsumerNaoLidas(): number {
  const { isConsumer } = useAuthContext();
  const query = useQuery({
    queryKey: ['conversas-consumer-badge'],
    queryFn: async () => contarConversasComNaoLidas(await listarConversasConsumer()),
    enabled: isConsumer,
    refetchOnWindowFocus: true,
  });
  return query.data ?? 0;
}
